var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFoundContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 13.5,
    rx: 12,
    ry: 2.5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4L6 0H18L22.0001 4V7H2V4ZM6.5 1H17.5L20.5 4V6H3.5V4L6.5 1Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88469 4.5C7.36259 4.5 7.75 4.88741 7.75 5.36531C7.75 6.05104 8.3094 6.6 8.99074 6.6H15.0093C15.6906 6.6 16.25 6.05104 16.25 5.36531C16.25 4.88741 16.6374 4.5 17.1153 4.5H21.5V12.2653C21.5 12.391 21.3961 12.5 21.2593 12.5H2.74074C2.60394 12.5 2.5 12.391 2.5 12.2653V4.5H6.88469Z",
    fill: "#F2F2F2",
    stroke: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundContent);
export default __webpack_public_path__ + "static/media/not-found-content.0c2727a0.svg";
export { ForwardRef as ReactComponent };